import React from 'react';
import styled from 'styled-components';
import ServiceCard from './ServiceCard';
import { Link } from 'react-scroll';
import StyledButton from '../common/StyledButton';
import { AnimatedSection } from '../common/AnimatedSection';
import {
  faPlane,
  faClock,
  faBriefcase,
  faGlassCheers,
  faTaxi,
  faRoute
} from '@fortawesome/free-solid-svg-icons';

const ServicesContainer = styled.section`
  padding: var(--spacing-xl) 0;
  background-color: #f8f8f8;
  
  @media (max-width: 768px) {
    padding: var(--spacing-lg) 0;
  }
`;

const SectionHeader = styled.div`
  text-align: center;
  max-width: 700px;
  margin: 0 auto var(--spacing-lg);
  padding: 0 var(--spacing-sm);
  
  @media (max-width: 768px) {
    padding: 0 1rem;
    margin-bottom: var(--spacing-md);
  }
`;

const SectionTitle = styled.h2`
  margin-bottom: var(--spacing-sm);
  position: relative;
  display: inline-block;
  padding-bottom: var(--spacing-sm);
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: var(--accent);
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-top: var(--spacing-md);
`;

const ServicesGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-sm);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 1rem;
    gap: var(--spacing-sm);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    padding: 0 0.75rem;
  }
`;

const CTAContainer = styled.div`
  text-align: center;
  margin-top: var(--spacing-lg);
`;

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: faPlane,
      title: 'Transferts Aéroports & Gares',
      description: "Arrivée ou départ, profitez d'un service ponctuel et confortable entre votre domicile et les aéroports d'Orly, Charles de Gaulle ou les gares parisiennes."
    },
    {
      icon: faClock,
      title: 'Mise à Disposition',
      description: "Réservez votre chauffeur pour une durée déterminée. Idéal pour les journées de rendez-vous professionnels ou shopping dans Paris ou autres grandes villes."
    },
    {
      icon: faBriefcase,
      title: 'Déplacements Professionnels',
      description: "Impressionnez vos clients ou partenaires avec un service VTC professionnel. Parfait pour les rendez-vous d'affaires et événements corporate."
    },
    {
      icon: faGlassCheers,
      title: 'Événements Spéciaux',
      description: "Mariages, soirées, événements culturels... Arrivez avec style et élégance à tous vos événements importants sans vous soucier du transport."
    },
    {
      icon: faTaxi,
      title: 'Service Longue Distance',
      description: "Voyagez confortablement pour vos déplacements en dehors de Paris. Service disponible dans toute la France pour vos besoins spécifiques."
    },
    {
      icon: faRoute,
      title: 'Circuits Touristiques Privés',
      description: "Découvrez Paris et ses environs avec un chauffeur connaissant parfaitement la capitale. Visites personnalisées des lieux emblématiques."
    }
  ];

  return (
    <ServicesContainer id="services">
      <SectionHeader>
        <AnimatedSection>
          <SectionTitle>Nos Services VTC Professionnels</SectionTitle>
          <SectionSubtitle>
            Des prestations sur mesure pour tous vos besoins de déplacement, avec un service d'excellence et une attention particulière à chaque détail.
          </SectionSubtitle>
        </AnimatedSection>
      </SectionHeader>

      <ServicesGrid>
        {services.map((service) => (
          <AnimatedSection key={service.title} delay={0}>
            <ServiceCard
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          </AnimatedSection>
        ))}
      </ServicesGrid>

      <CTAContainer>
        <Link to="contact" smooth={true} duration={800} offset={-100}>
          <StyledButton variant="primary" size="large">
            Demander un Devis Personnalisé
          </StyledButton>
        </Link>
      </CTAContainer>
    </ServicesContainer>
  );
};

export default ServicesSection; 